export default __webpack_public_path__ + "static/media/5c0a3119faff9c7c302fb51229e85446.svg";